import { BarEditPageSaveReason } from './bar-edit-page-save-reason.enum';

/** Options for performing a save operation. */
export class BarEditPageSaveOptions {
    /** The reason why a save is performed */
    reason?: BarEditPageSaveReason = BarEditPageSaveReason.Custom;
    /** Extra data/state/context for the save operation. */
    data?: any;
    /** Whether to suppress the save message. */
    suppressSaveMessage? = false;
    /** Whether the page should exist edit modus and go back into readonly or disabled modus. */
    exitEdit? = false;
}
